//Get Teams
export const GET_SUBCATEGORIES = "GET_SUBCATEGORIES";

//Insert Team
export const INSERT_SUBCATEGORY = "INSERT_SUBCATEGORY";

//Update Team
export const UPDATE_SUBCATEGORY = "UPDATE_SUBCATEGORY";

//Delete Team
export const DELETE_SUBCATEGORY = "DELETE_SUBCATEGORY";

//Toggle Status
export const TOGGLE_SUBCATEGORY_STATUS = "TOGGLE_SUBCATEGORY_STATUS";

//Open Dialog
export const OPEN_SUBCATEGORY_DIALOG = "OPEN_SUBCATEGORY_DIALOG";

//Close Dialog
export const CLOSE_SUBCATEGORY_DIALOG = "CLOSE_SUBCATEGORY_DIALOG";

//Open Toast
export const OPEN_SUBCATEGORY_TOAST = "OPEN_SUBCATEGORY_TOAST";

//Close Toast
export const CLOSE_SUBCATEGORY_TOAST = "CLOSE_SUBCATEGORY_TOAST"; 